<template>
	<div
		v-if="!isProductLoading"
		class="private-order-detail-action"
		:class="{ 'mobile-view': isMobileView }"
	>
		<div
			class="action-content-wrapper"
			:class="{ 'mobile-view': isMobileView }"
			:style="{ top: `${containerTop}px` }"
		>
			<div class="content-header">
				<span>Atur Jumlah</span>
			</div>

			<div class="divider"></div>

			<div class="content-body">
				<div class="stock-wrapper">
					<div class="input-counter-wrapper" :class="{ 'mobile-view': isMobileView }">
						<private-order-input-quantity v-model="quantity" :min="0" :max="999999" />
					</div>

					<span class="stock-text">
						Stock:
						<span :class="{ 'stock-red': isStockRed }">{{ stockView }}</span>
					</span>
				</div>

				<div class="amount-wrapper">
					<span class="amount-label">Subtotal</span>

					<span class="amount-value">{{ formatMoney(subtotal, 'IDR', false) }}</span>
				</div>
			</div>

			<div class="divider"></div>

			<div class="content-footer">
				<button
					class="btn btn-primary btn-md d-flex align-items-center justify-content-center w-100"
					:disabled="isButtonDisabled"
					@click="handleClickBuy"
				>
					<span>Beli Sekarang</span>
				</button>
			</div>
		</div>
	</div>
	<div v-else class="private-order-detail-action-skeleton skeleton"></div>
</template>

<script>
import { mapGetters } from 'vuex';

import PrivateOrderInputQuantity from '@/components/private-orders/detail/InputQuantity.vue';
import { formatMoney } from '@/lib/helper';

export default {
	components: {
		PrivateOrderInputQuantity,
	},
	props: {
		yPos: {
			type: Number,
			default: 0,
		},
		product: {
			type: Object,
			required: true,
		},
		isProductLoading: {
			type: Boolean,
			required: true,
		},
		disabled: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {
			quantity: 0,
			subtotal: 0,
		};
	},
	computed: {
		...mapGetters({
			isMobileView: 'privateOrder/isMobileView',
		}),
		containerTop() {
			if (this.isMobileView) return 0;
			const marginTop = 24;
			const navHeight = 62.5;
			const baseTop = marginTop + navHeight;
			const maxTop = 126;
			const currentTop = this.yPos + baseTop;
			return currentTop < maxTop ? currentTop : maxTop;
		},
		stock() {
			return this.product.distributor.stock.quantity;
		},
		isHasWholesale() {
			if (this.isProductLoading) return false;
			const wholesale = this.product.distributor?.wholesale;
			if (wholesale && wholesale.length > 0) return true;
			return false;
		},
		stockView() {
			if (this.stock < 100) {
				return '< 100';
			}
			return this.stock;
		},
		isStockRed() {
			return this.stock < 100;
		},
		isButtonDisabled() {
			return this.quantity <= 0 || this.disabled;
		},
	},
	watch: {
		quantity: {
			handler(newVal) {
				this.subtotal = this.calculateSubtotal(newVal);
			},
		},
	},
	methods: {
		formatMoney,
		calculateSubtotal(quantity) {
			if (!this.isHasWholesale) {
				return quantity * this.product.distributor.price;
			}

			let price = 0;
			const maxValues = [];
			const wholesale = this.product.distributor.wholesale;

			wholesale.forEach((item) => {
				const min = parseInt(item.min);
				const max = parseInt(item.max);
				maxValues.push(max);
				if (quantity >= min && quantity <= max) {
					price = parseInt(item.price);
				}
			});

			const highestMax = Math.max(...maxValues);
			const highestMaxIndex = maxValues.indexOf(highestMax);

			if (quantity > highestMax) {
				return quantity * parseInt(wholesale[highestMaxIndex].price);
			}

			return quantity * price;
		},
		handleClickBuy() {
			this.$router.push({
				name: 'wholesale-order-checkout',
				params: { slug: this.$route.params.slug },
				query: { qty: this.quantity },
			});
		},
	},
};
</script>

<style scoped lang="scss">
.private-order-detail-action {
	width: 268px;
	min-width: 268px;
	max-width: 268px;
	position: relative;

	&.mobile-view {
		margin-top: 18px;
		width: 100%;
		max-width: 516px;
	}
}

.private-order-detail-action-skeleton {
	width: 268px;
	min-width: 268px;
	max-width: 268px;
	height: 200px;
	border-radius: 8px;

	&.mobile-view {
		margin-top: 18px;
		width: 100%;
		max-width: 516px;
	}
}

.action-content-wrapper {
	width: 268px;
	min-width: 268px;
	max-width: 268px;
	height: auto;
	position: sticky;
	display: flex;
	flex-direction: column;
	border-radius: 8px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.075);
	border: 0.5px solid #d9dadd75;
	background-color: #ffffff;

	&.mobile-view {
		position: inherit;
		width: 100%;
		max-width: 516px;
	}
}

.divider {
	width: 100%;
	height: auto;
	border-top: 0.5px solid rgba(0, 0, 0, 0.1);
}

.content-header {
	width: 100%;
	height: auto;
	display: flex;
	padding: 12px 18px;

	& > span {
		font-size: 16px;
		font-weight: 600;
		line-height: 18px;
		color: #000000;
	}
}

.content-body {
	width: 100%;
	height: auto;
	padding: 12px 18px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.stock-wrapper,
.amount-wrapper {
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.content-footer {
	width: 100%;
	height: auto;
	padding: 12px 18px;
	display: flex;
	justify-content: center;
}

.input-counter-wrapper {
	width: 120px;

	&.mobile-view {
		width: 160px;
	}
}

span.stock-text {
	font-size: 16px;
	line-height: 18px;
	font-weight: 400;
	color: #000000;

	& > span.stock-red {
		color: #f04438;
	}
}

span.amount-label {
	font-size: 13px;
	line-height: 18px;
	font-weight: 400;
	color: #000000;
}

span.amount-value {
	font-size: 20px;
	line-height: 22px;
	font-weight: 600;
	color: #f28900;
}
</style>
